import { render, staticRenderFns } from "./clickcardpop.vue?vue&type=template&id=62d69966&scoped=true&"
import script from "./clickcardpop.vue?vue&type=script&lang=js&"
export * from "./clickcardpop.vue?vue&type=script&lang=js&"
import style0 from "./clickcardpop.vue?vue&type=style&index=0&id=62d69966&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d69966",
  null
  
)

export default component.exports